import IconFacebook from '@/components/icons/IconFacebook.vue';
import IconInstagram from '@/components/icons/IconInstagram.vue';
import IconYouTube from '@/components/icons/IconYouTube.vue';

export default {
  name: 'HeaderSocial',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      socialConfig: [
        {
          key: 'facebook',
          icon: IconFacebook
        },
        {
          key: 'instagram',
          icon: IconInstagram
        },
        {
          key: 'youtube',
          icon: IconYouTube
        }
      ]
    };
  },
  watch: {},
  created() {},
  mounted() {},
  computed: {
    list() {
      let list = [];
      if (this.data?.contacts) {
        list = this.socialConfig.reduce((acc, item) => {
          let link = this.data.contacts[item.key];

          return link ? [...acc, { ...item, link }] : acc;
        }, []);
      }
      return list;
    }
  },
  methods: {}
};
